module.exports = __webpack_public_path__ + "static/media/whatsapp2-large.03fabc31.svg";